import React, { useEffect, useState, createElement } from 'react';
import { Calendar, Lock, AlertTriangle, X, MousePointerClick, Download, Mail, MessageCircle, CheckCircle2, Clock, Video, ArrowRight, Sparkles, HelpCircle } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // Function to get next Thursday date
  const getNextThursday = () => {
    const now = new Date();
    const estTime = new Date(now.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    const currentDay = estTime.getDay();
    const currentHour = estTime.getHours();
    let daysUntilThursday = 0;
    if (currentDay === 4) {
      if (currentHour >= 18) {
        daysUntilThursday = 7;
      } else {
        daysUntilThursday = 0;
      }
    } else if (currentDay < 4) {
      daysUntilThursday = 4 - currentDay;
    } else {
      daysUntilThursday = 7 - currentDay + 4;
    }
    const nextThursday = new Date(estTime);
    nextThursday.setDate(estTime.getDate() + daysUntilThursday);
    return nextThursday.getDate();
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('init', '4285913388317138');
    window.fbq('track', 'PageView');
    (function (e: any, n: any, t: any, i: any, p: any, a: any, s: any) {
      e[i] || ((p = e[i] = function () {
        p.process ? p.process.apply(p, arguments) : p.queue.push(arguments);
      }).queue = [], p.t = +new Date(), (a = n.createElement(t)).async = 1, a.src = 'https://static.newsbreak.com/business/tracking/nbpixel.js?t=' + 864e5 * Math.ceil(new Date().getTime() / 864e5), (s = n.getElementsByTagName(t)[0]).parentNode.insertBefore(a, s));
    })(window, document, 'script', 'nbpix', null, null, null);
    (window as any).nbpix('init', 'ID-2016254252686041090');
    (window as any).nbpix('event', 'view_content', {
      nb_value: 0
    });
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/nrxtdp5ht5.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='nrxtdp5ht5']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/nrxtdp5ht5/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      try {
        document.head.removeChild(playerScript);
        document.head.removeChild(embedScript);
        document.head.removeChild(style);
      } catch (e) {}
    };
  }, []);
  const breakoutVideos = [{
    id: '1173156247',
    title: '¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?'
  }, {
    id: '1173156261',
    title: 'Ya he invertido en otros programas y no me funcionaron. ¿Qué hace a este diferente?'
  }, {
    id: '1173156277',
    title: 'No tengo tiempo para implementar otro sistema complejo.'
  }, {
    id: '1173156217',
    title: 'Me preocupa el costo de la inversión. ¿Cuál es el ROI real?'
  }, {
    id: '1173156206',
    title: '¿No puedo simplemente hacer lo mismo con ChatGPT y otras herramientas gratuitas?'
  }];
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-4941">
      <noscript data-id="element-4942">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4943" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60 pointer-events-none" data-id="element-4944">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-4945" />
      </div>

      {/* Ambient glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-4946" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-4947" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-4948" />

      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-4949" />

      {/* ============ TOP DATE BAR ============ */}
      <div className="relative z-10 bg-gradient-to-r from-amber-400 to-amber-500 py-2.5 md:py-3.5 px-4" data-id="element-4950">
        <div className="max-w-5xl mx-auto text-center" data-id="element-4951">
          <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-4952">
            <Calendar className="w-4 h-4 md:w-5 md:h-5 text-[#0a1428]" data-id="element-4953" />
            <h1 className="text-[11px] sm:text-xs md:text-sm lg:text-base font-black uppercase tracking-tight text-[#0a1428]" data-id="element-4954">
              Reservada La Fecha: Jueves {getNextThursday()} · 7PM EST (Hora
              Miami)
            </h1>
          </div>
        </div>
      </div>

      {/* ============ MAIN CONTENT ============ */}
      <main className="relative z-10 max-w-6xl mx-auto px-4 lg:px-8 py-10 md:py-16 lg:py-20" data-id="element-4955">
        {/* Hero / Headline */}
        <section className="text-center mb-10 md:mb-14 lg:mb-18" data-id="element-4956">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-1.5 mb-6 md:mb-8" data-id="element-4957">
            <Lock className="w-3.5 h-3.5 text-emerald-400" data-id="element-4958" />
            <span className="text-emerald-400 text-[11px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-4959">
              Tu Lugar Está Confirmado
            </span>
          </div>

          <h2 className="text-[1.6rem] md:text-4xl lg:text-5xl xl:text-6xl font-black leading-[1.05] tracking-tight mb-4 md:mb-5 max-w-4xl mx-auto" data-id="element-4960">
            Completa Estos 3 Pasos Importantes{' '}
            <span className="relative inline-block" data-id="element-4961">
              <span className="relative z-10 text-amber-400" data-id="element-4962">
                Antes De Que Te Vayas
              </span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-4963" />
            </span>
          </h2>

          <p className="text-sm md:text-lg lg:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-4964">
            Para aprovechar al máximo la masterclass
          </p>
        </section>

        {/* ============ VIDEO + WHATSAPP GRID ============ */}
        <section className="mb-12 md:mb-16 lg:mb-20" data-id="element-4965">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-5 lg:gap-6" data-id="element-4966">
            {/* Video — left 3 cols */}
            <div className="lg:col-span-3" data-id="element-4967">
              <div className="w-full overflow-hidden rounded-2xl border-2 border-amber-500/30 bg-[#0f1b35]" style={{
              boxShadow: '0 0 50px rgba(245, 158, 11, 0.15), 0 20px 60px -20px rgba(0,0,0,0.6)'
            }} data-id="element-4968">
                {/* @ts-expect-error custom element */}
                <wistia-player media-id="nrxtdp5ht5" aspect="1.7777777777777777" data-id="element-4969"></wistia-player>
              </div>
            </div>

            {/* WhatsApp Step #1 — right 2 cols */}
            <div className="lg:col-span-2 flex flex-col" data-id="element-4970">
              <div className="bg-gradient-to-br from-[#25D366]/15 to-[#128C7E]/10 border-2 border-[#25D366]/40 rounded-2xl p-5 md:p-6 flex-1 flex flex-col shadow-[0_0_40px_rgba(37,211,102,0.15)]" data-id="element-4971">
                <div className="inline-flex items-center gap-2 bg-[#25D366]/20 border border-[#25D366]/40 rounded-full px-3 py-1.5 self-start mb-4" data-id="element-4972">
                  <span className="text-[#25D366] text-[10px] md:text-xs font-black uppercase tracking-[0.18em]" data-id="element-4973">
                    Paso #1
                  </span>
                </div>

                <h3 className="text-lg md:text-xl lg:text-2xl font-black text-white leading-tight mb-3" data-id="element-4974">
                  Únete Al Grupo De WhatsApp
                </h3>

                <p className="text-sm md:text-base text-gray-300 mb-5 flex-1 leading-relaxed" data-id="element-4975">
                  <span className="font-bold text-[#25D366]" data-id="element-4976">¡IMPORTANTE!</span>{' '}
                  Únete ahora al grupo exclusivo de WhatsApp para recibir
                  recordatorios y contenido extra.
                </p>

                <a href="https://chat.whatsapp.com/CxQPcrB8ZuiFLvBx3MEsen" target="_blank" rel="noopener noreferrer" className="group w-full bg-[#25D366] hover:bg-[#1da851] text-white font-black text-sm md:text-base uppercase tracking-tight rounded-xl py-3.5 md:py-4 px-4 transition-all duration-300 flex items-center justify-center gap-2 shadow-[0_10px_30px_-10px_rgba(37,211,102,0.6)] hover:shadow-[0_10px_30px_-5px_rgba(37,211,102,0.8)] transform hover:scale-[1.02]" data-id="element-4977">
                  <MessageCircle className="w-4 h-4 md:w-5 md:h-5" data-id="element-4978" />
                  UNIRME AL GRUPO
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 transition-transform group-hover:translate-x-1" data-id="element-4979" />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ============ STEP #2 — REGALO EXCLUSIVO ============ */}
        <section className="mb-12 md:mb-16 lg:mb-20 max-w-4xl mx-auto" data-id="element-4980">
          <div className="text-center mb-6 md:mb-8" data-id="element-4981">
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-4" data-id="element-4982">
              <Sparkles className="w-3.5 h-3.5 text-amber-400" data-id="element-4983" />
              <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-4984">
                Paso #2
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black leading-tight" data-id="element-4985">
              Regalo <span className="text-amber-400" data-id="element-4986">Exclusivo</span>
            </h2>
          </div>

          {/* Guide preview image — non-clickable */}
          <div className="mb-5 relative" data-id="element-4987">
            <div className="relative rounded-2xl overflow-hidden border-2 border-amber-500/30" data-id="element-4988">
              <img src="https://cdn.magicpatterns.com/uploads/qGszUSvXKGkMXKzhkKHKP9/heylloyd-image-1769473134106.png" alt="Regalo Gratis - Guía Completa de Implementación" className="w-full" data-id="element-4989" />
            </div>
          </div>

          {/* Download CTA button */}
          <div className="mb-6" data-id="element-4990">
            <a href="https://drive.google.com/file/d/1UwCS-6hTXssQIqMUObPKvMnumSsTNm5u/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg lg:text-xl uppercase tracking-tight rounded-2xl py-4 md:py-5 lg:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden flex items-center justify-center gap-2.5 md:gap-3" data-id="element-4991">
              <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-4992" />
              <span data-id="element-4993">DESCARGAR LA GUÍA AHORA</span>
              <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-4994" />
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-4995" />
            </a>
          </div>

          <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 md:p-7 lg:p-8" data-id="element-4996">
            <p className="text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed space-y-3" data-id="element-4997">
              <span className="block" data-id="element-4998">
                Antes del workshop, quiero que descargues esta guía y la leas
                con calma.
              </span>
              <span className="block mt-3" data-id="element-4999">
                Esta guía no es un regalo más. No es un PDF para ejecutar. Y no
                es algo para "aplicar" todavía.
              </span>
              <span className="block mt-3" data-id="element-5000">
                Su único objetivo es ayudarte a llegar al workshop con el marco
                mental correcto.
              </span>
              <span className="block mt-3" data-id="element-5001">
                La mayoría de las personas se equivoca antes de empezar—no
                porque no sepa qué hacer, sino porque empieza por el lugar
                incorrecto.
              </span>
              <span className="block mt-3 text-white font-semibold" data-id="element-5002">
                Esta guía te ayudará a entender el orden correcto para que el
                contenido del workshop tenga sentido desde el primer minuto.
              </span>
            </p>
          </div>
        </section>

        {/* ============ STEP #3 — CHECK EMAIL ============ */}
        <section className="mb-14 md:mb-20 lg:mb-24 max-w-4xl mx-auto" data-id="element-5003">
          <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 md:p-6 lg:p-7 flex items-start gap-4" data-id="element-5004">
            <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-5005">
              <Mail className="w-5 h-5 lg:w-6 lg:h-6 text-amber-400" data-id="element-5006" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-5007">
              <div className="inline-flex items-center gap-2 mb-2" data-id="element-5008">
                <span className="text-amber-400 text-[10px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-5009">
                  Paso #3
                </span>
              </div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-black text-white leading-tight mb-2" data-id="element-5010">
                Revisa Tu Email
              </h3>
              <p className="text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed" data-id="element-5011">
                Revisa tu bandeja de entrada (y spam) para confirmar tu acceso
                al evento.
              </p>
            </div>
          </div>
        </section>

        {/* ============ BREAKOUT VIDEOS ============ */}
        <section className="max-w-6xl mx-auto" data-id="element-5012">
          <div className="text-center mb-8 md:mb-12 lg:mb-14" data-id="element-5013">
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-4" data-id="element-5014">
              <HelpCircle className="w-3.5 h-3.5 text-amber-400" data-id="element-5015" />
              <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-5016">
                Preguntas Frecuentes
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black leading-tight mb-3 md:mb-4" data-id="element-5017">
              ¿Tienes Dudas?{' '}
              <span className="text-amber-400" data-id="element-5018">Las Resolvemos Aquí</span>
            </h2>
            <p className="text-sm md:text-base lg:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-5019">
              Mira estos videos cortos para resolver las preguntas más comunes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6" data-id="element-5020">
            {breakoutVideos.map((v, idx) => <div key={v.id} className="group bg-white/[0.025] border border-white/[0.08] rounded-2xl overflow-hidden flex flex-col hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300" data-id="element-5021">
                <div className="relative bg-[#0f1b35]" data-id="element-5022">
                  <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-5023">
                    <iframe src={`https://player.vimeo.com/video/${v.id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title={`BREAKOUT VID ${idx + 1}`} data-id="element-5024" />
                  </div>
                </div>
                <div className="p-4 md:p-5 flex-1 flex items-start gap-3" data-id="element-5025">
                  <div className="w-7 h-7 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-5026">
                    <span className="text-amber-400 text-xs font-black" data-id="element-5027">
                      {idx + 1}
                    </span>
                  </div>
                  <p className="font-bold text-sm md:text-[15px] text-white leading-snug" data-id="element-5028">
                    {v.title}
                  </p>
                </div>
              </div>)}
          </div>
        </section>
      </main>

      <Footer data-id="element-5029" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-5030">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)]" onClick={e => e.stopPropagation()} data-id="element-5031">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-5032">
              <X className="w-6 h-6" data-id="element-5033" />
            </button>
            <h2 className="text-2xl md:text-3xl font-black mb-6 uppercase tracking-tight" data-id="element-5034">
              Términos y Condiciones
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-5035">
              <p data-id="element-5036">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5037">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-5038">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5039">
                2. Uso del Servicio
              </h3>
              <p data-id="element-5040">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5041">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-5042">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5043">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-5044">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5045">
                5. Modificaciones
              </h3>
              <p data-id="element-5046">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5047">Contacto</h3>
              <p data-id="element-5048">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-amber-400 hover:text-amber-300" data-id="element-5049">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-5050">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)]" onClick={e => e.stopPropagation()} data-id="element-5051">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-5052">
              <X className="w-6 h-6" data-id="element-5053" />
            </button>
            <h2 className="text-2xl md:text-3xl font-black mb-6 uppercase tracking-tight" data-id="element-5054">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-5055">
              <p data-id="element-5056">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5057">
                1. Información que Recopilamos
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-5058">
                <li data-id="element-5059">Nombre y dirección de correo electrónico</li>
                <li data-id="element-5060">Información de registro del evento</li>
                <li data-id="element-5061">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5062">
                2. Uso de la Información
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-5063">
                <li data-id="element-5064">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-5065">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-5066">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-5067">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5068">
                3. Compartir Información
              </h3>
              <p data-id="element-5069">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5070">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-5071">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-5072">Contacto</h3>
              <p data-id="element-5073">
                <a href="mailto:support@truemarketer.com" className="text-amber-400 hover:text-amber-300" data-id="element-5074">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      <WhatsAppButton data-id="element-5075" />
    </div>;
}